

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { API_BASE_URL } from '../../config';
import { LoadingSpinner } from '../../Components/spinner/spinner';

export const StaffAsset32Component = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl. No', width: 70 },
    { id: 'fe_name', field: 'fe_name', headerName: 'Financial Establishment', width: 200 },
    { id: 'designation', field: 'designation', headerName: 'Designation', width: 150 },
    { id: 'phone', field: 'phone', headerName: 'Phone Number', width: 150 },
    { id: 'email', field: 'email', headerName: 'Email', width: 200 },
    // { id: 'notification', field: 'notification', headerName: 'Notification', width: 250 },
    { id: 'date', field: 'date', headerName: 'Date', width: 150 },
    { id: 'notificationNo', field: 'notificationNo', headerName: 'Notification No', width: 160 },
    {
      id: 'notification',
      field: 'notification',
      headerName: '3(2) Notification',
      width: 180,
      renderCell: (params) =>
        params.value && params.value !== '-' ? (
          <a
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
          >
            View
          </a>
        ) : (
          <span>-</span>
        ),
    },
  ];

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/asset-mgmt/asset32/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          fe_name: item.fe ? item.fe.name_of_fe || '-' : '-',
          designation: item.fe ? item.fe.designation || '-' : '-',
          phone: item.fe ? item.fe.ph_number || '-' : '-',
          email: item.fe ? item.fe.email || '-' : '-',
          notification: item.notification || '-',
          date: item.date
            ? new Date(item.date).toLocaleDateString('en-GB').replace(/\//g, '-')
            : '-',
          notificationNo: item.notification_no || '-',
          notificationLink: item.link || '-', // assuming API returns link property
        }));

        setRows(apiData);
        setSnackbarMessage('Asset 3(2) data loaded successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch Asset 3(2) data:', error);
        setSnackbarMessage('Failed to load Asset 3(2) data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  }, []);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
        <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
          Asset 3(2)
        </Typography>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort={true}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
